import { useEffect, useRef } from "react";
import getSocket from "../services/socket";

const useSocket = (eventName, handler) => {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!eventName) return;
    const socket = getSocket();
    const wrappedHandler = (...args) => handlerRef.current(...args);
    socket.on(eventName, wrappedHandler);
    return () => socket.off(eventName, wrappedHandler);
  }, [eventName]);

  return getSocket();
};

export default useSocket;
